export default "<p>\r\n  first-collection works!\r\n</p>\r\n"